angular.module('components.caBarcodeScanningInput', [])
    .component('caBarcodeScanningInput', {
        templateUrl: 'main/order/orderdelivery/components/barcodescanninginput.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            onOrderArticlesRetrieved: '&',
            order: '<'
        },
        controller: controller
    });

// @ngInject
function controller($translate, OrdersApiService, ToasterService, loadSpinnerService, BarcodeService, confirmationDialogService) {
    var vm = this;

    vm.scannedBarcodes = '';

    vm.getArticlesAndQuantites = getArticlesAndQuantites;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    function onInit() {
        var fileInputDomElement = $("#xlf")[0];

        fileInputDomElement.addEventListener('change', handleFile, false);
        function handleFile(e) {
            var files = e.target.files;
            var i, f;
            for (i = 0, f = files[i]; i !== files.length; ++i) {
                var reader = new FileReader();

                reader.onload = onLoadFunction;
                loadSpinnerService.start('mainSpinner');
                reader.readAsArrayBuffer(f);
            }

            function onLoadFunction(e) {
                try {
                    var data = "";
                    var splitData = [];
                    var bytes = new Uint8Array(e.target.result);
                    var length = bytes.byteLength;
                    for (var i = 0; i < length; i++) {
                        data += String.fromCharCode(bytes[i]);
                    }
                    // // linebreak for Windows
                    // var dos = data.split('\r\n');
                    // // linebreak for Mac OS 
                    // var unix = data.split('\n');
                    // var unixNumOfItems = getNumberOfItemSets(unix);
                    // var dosNumOfItems = getNumberOfItemSets(dos);

                    // if (unix.length > 1) {
                    //     splitData = unix;
                    // }
                    // if (dos.length > 1) {
                    //     splitData = dos;
                    // }

                    var splitData = data.split(/\r?\n|\r/g)
                    _.forEach(splitData, function (textRow) {
                        var splitRow = textRow.split(',');
                        if (splitRow[0].toLowerCase() === 'inventering' || splitRow[0].toLowerCase() === 'internorder') {
                            for (var i = 0; i < splitRow[2]; i++) {
                                vm.scannedBarcodes += splitRow[1] + "\n";
                            }
                        }
                    });
                } catch (error) {
                    console.log(error);
                } finally {
                    loadSpinnerService.stop('mainSpinner');
                }
            }
        }
    }
    function onChanges() {

    }
    function onDestroy() {

    }
    function getNumberOfItemSets(splitData) {

        var lenInventory = splitData[0].toLowerCase().split('inventering').length;
        var lenInternOrder = splitData[0].toLowerCase.splitData("internorder").length;
        if (lenInventory > 0) {
            return splitData.length;
        }
        else if (lenInternOrder > 0) {
            return splitData.length;
        }
        return 0;

    }
    function getArticlesAndQuantites() {
        var barcodesArray = [];

        vm.scannedBarcodes = BarcodeService.formatBarcodesString(vm.scannedBarcodes);

        _.forEach(vm.scannedBarcodes.split('\n'), function (barcode) {
            barcodesArray.push(BarcodeService.cleanBarcode(barcode));
        });

        var companyId = (vm.order.company !== undefined && 
            vm.order.orderType.orderSystemType !== 'internal') ? vm.order.company.id : 0;

        loadSpinnerService.start('mainSpinner');
        OrdersApiService.getOrderArticlesForBarcodes(barcodesArray, companyId, vm.order.currency.id, vm.order.currencyRate).then(function (response) {
            //If backend returns any unfound barcodes present them to the user to decide how to proceed
            if (response.notFoundBarcodes && response.notFoundBarcodes.length > 0) {
                var message = $translate.instant('order.scanNotAllBarcodesCouldBeAdded') + '.<br><br>' +
                    '<table class="table" style="width:100%">' +
                    '<thead><tr><th>' + $translate.instant('article.barcode') + '</th><th>' + $translate.instant('order.scanFailureReason') + '</th></tr>' +
                    '<tbody>';
                _.forEach(response.notFoundBarcodes, function (nfb) {
                    if (nfb.reasonCode === 'order.scanErrorBarcodeOnAnotherSupplier') {
                        message += '<tr><td>' + nfb.barcode + '</td><td>' + $translate.instant(nfb.reasonCode) + ': ' + nfb.supplierName + '</td></tr>';
                    } else {
                        message += '<tr><td>' + nfb.barcode + '</td><td>' + $translate.instant(nfb.reasonCode) + '</td></tr>';
                    }
                });
                message += '</tbody></table><br><br>' +
                    $translate.instant('order.scanAreYouSureYouWantToContinue') + '? ' +
                    response.articles.length + ' ' + $translate.instant('common.of') + ' ' +
                    (response.articles.length + response.notFoundBarcodes.length) + ' ' +
                    $translate.instant('order.scanWillBeAdded') + '.';

                confirmationDialogService.showDialog(message, undefined, 'lg').then(function (result) {
                    if (result === true) {
                        handleRetrievedOrderArticles(response.articles);
                    }
                });
            } else {
                handleRetrievedOrderArticles(response.articles);
            }
        }, function (error) {
            ToasterService.showError(error.message);
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function handleRetrievedOrderArticles(articles) {
        if (vm.order.orderType.orderSystemType.toLowerCase() === 'internal' && vm.order.fromLocation && vm.order.fromLocation.id) {
            var orderRows = [];
            var articleVariantIds = [];
            var locationIds = [vm.order.fromLocation.id];
            _.forEach(articles, function (orderArticle) {
                _.forEach(orderArticle.orderRows, function (orderRow) {
                    orderRows.push(orderRow);
                    articleVariantIds.push(orderRow.articleVariant.id);
                });
            });
            OrdersApiService.getStocksForArticleVariants(articleVariantIds, locationIds).then(function (stocks) {
                _.forEach(stocks.data, function (stock) {
                    var orderRow = _.find(orderRows, function (orderRow) {
                        return orderRow.articleVariant.id === stock.articleVariant.id;
                    });

                    if (orderRow) {
                        orderRow.originalPurchasePrice = stock.purchaseCost;
                        orderRow.effectivePurchasePrice = stock.purchaseCost;
                        orderRow.purchaseCost = stock.purchaseCost;
                    }

                });
                vm.onOrderArticlesRetrieved({ orderArticles: articles });

            }, function (error) { ToasterService.showError(error.message); });
        } else {
            vm.onOrderArticlesRetrieved({ orderArticles: articles });
        }

        vm.scannedBarcodes = '';
    }
}
